import PadraoModel from 'src/core/model/PadraoModel.js'

export default class UsadosbrCombustivelModel extends PadraoModel {
  recurso = 'usadosbr/combustiveis';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Combustíveis Usadosbr';

  colunasGrid = [
  ];

  form = {
    id: null,
    nome: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
